export default __webpack_public_path__ + "static/PPNeueMontreal-Book-b07e9e29c05e31111e2badfea2fce163.ttf";